"use client";

import { SiteNav, SiteFooter, SUPPORT_STYLES, CONTACT_STYLES } from "./chrome";
import { STYLES as BASE_STYLES } from "./LandingV2";

const REGISTER_URL = "https://dashboard.lvlup-app.com/auth/register";

const stats = [
  { v: "1,000+", l: "Active Coaches" },
  { v: "50+", l: "Countries" },
  { v: "20 days", l: "App Launch" },
  { v: "0%", l: "Commission" },
];

export default function ContactV2() {
  return (
    <div className="lvlup-landing">
      <style dangerouslySetInnerHTML={{ __html: BASE_STYLES + SUPPORT_STYLES + CONTACT_STYLES }} />
      <SiteNav current="contact" />

      <main>

      {/* HERO */}
      <section className="sp-hero">
        <div className="sp-hero-grid" />
        <div className="sp-hero-glow" />
        <div className="lp-container sp-hero-inner">
          <span className="lp-eyebrow">
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 8c0-3 2-5 5-5s5 2 5 5-2 4-5 4c-1 0-2-.2-3-.5L2 12l.5-2.2C2.2 9.3 2 8.7 2 8z" />
            </svg>
            Let's Connect
          </span>
          <h1>Ready to transform <span className="lp-accent">your coaching?</span></h1>
          <p className="sp-lead">
            Whether you're just starting out or scaling to new heights, our team is here to guide you
            every step of the way. Get personalized support and expert advice.
          </p>
          <div className="sp-hero-ctas">
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" className="lp-btn lp-btn-primary lp-btn-lg">
              Start Your Free Trial Today
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M3 7h8m-3-3l3 3-3 3" /></svg>
            </a>
          </div>

          <div className="sp-trio">
            <div className="sp-trio-cell">
              <div className="sp-trio-icon">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 2L4 11h5l-1 7 7-9h-5l1-7z" /></svg>
              </div>
              <h3>Quick Response</h3>
              <p>We reply to every inquiry within 24 hours, usually much faster.</p>
            </div>
            <div className="sp-trio-cell">
              <div className="sp-trio-icon">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="10" cy="10" r="7" /><circle cx="10" cy="10" r="3.5" /><circle cx="10" cy="10" r="1" fill="currentColor" /></svg>
              </div>
              <h3>Expert Guidance</h3>
              <p>Personalized advice from coaches who've scaled six-figure practices.</p>
            </div>
            <div className="sp-trio-cell">
              <div className="sp-trio-icon">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M5 16l5-12 5 12M7 11h6" /></svg>
              </div>
              <h3>Growth Support</h3>
              <p>From your first client to your hundredth, we help you scale.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT BLOCK */}
      <section>
        <div className="lp-container">
          <div className="cp-grid">
            <div className="sp-card">
              <h3>Contact Information</h3>
              <div className="sp-row">
                <div className="sp-row-icon">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="14" height="11" rx="2" /><path d="M3 7l7 5 7-5" /></svg>
                </div>
                <div>
                  <div className="sp-label">Email</div>
                  <div>
                    <a href="mailto:support@lvlup-app.com" className="sp-strong">support@lvlup-app.com</a>
                    <span className="sp-meta">We'll respond within 24 hours</span>
                  </div>
                </div>
              </div>
              <div className="sp-row">
                <div className="sp-row-icon">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 3h3l1 4-2 1c1 3 3 5 6 6l1-2 4 1v3a2 2 0 01-2 2C7 18 2 13 2 5a2 2 0 012-2z" /></svg>
                </div>
                <div>
                  <div className="sp-label">Phone</div>
                  <div>
                    <a href="tel:+18773558587" className="sp-strong">+1 (877) 355-8587</a>
                    <span className="sp-meta">Mon–Fri · 9 AM – 6 PM EST</span>
                  </div>
                </div>
              </div>
              <div className="sp-row">
                <div className="sp-row-icon">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="10" cy="10" r="7" /><path d="M10 6v4l3 2" /></svg>
                </div>
                <div>
                  <div className="sp-label">Business Hours</div>
                  <div>
                    <span className="sp-strong">Monday — Friday · 9 AM – 6 PM EST</span>
                    <span className="sp-meta">Saturday &amp; Sunday closed</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="sp-card">
              <h3>About LVLUP</h3>
              <p className="cp-about-lead">
                LVLUP is the all-in-one coaching platform trusted by 1,000+ coaches worldwide. We're
                dedicated to helping fitness and wellness professionals scale their businesses with
                the operating system they actually deserve.
              </p>
              <div className="cp-about-stats">
                {stats.map((s) => (
                  <div key={s.l} className="cp-about-stat">
                    <div className="cp-v">{s.v}</div>
                    <div className="cp-l">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <div className="lp-cta-banner">
        <div className="lp-cta-card">
          <div>
            <h2 className="lp-h2 lp-cta-h2">Got a question?<br />We've got time.</h2>
            <p className="lp-cta-p">Drop us an email or book a quick call — we'd love to show you what LVLUP can do for your practice.</p>
          </div>
          <a href="mailto:support@lvlup-app.com" className="lp-btn lp-btn-primary lp-btn-lg">
            Email us
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M3 7h8m-3-3l3 3-3 3" /></svg>
          </a>
        </div>
      </div>

      </main>

      <SiteFooter />
    </div>
  );
}
